import React, { useState } from 'react';
// import clsx from 'clsx'
import { useNavigate } from 'react-router-dom';
import useAddAssetRequest from 'sdk/hooks/useAddAssetRequest';
import MessageModal from 'components/shared/modals/MessageModal';
import Modal from 'components/shared/modals/Modal';
import Input from 'components/shared/Input';
import Button from 'components/shared/Button';
import styles from './AssetRequestModal.module.scss';

function AssetRequestModal({ onClose }: {
  onClose: () => void,
}) {
  const [name, setName] = useState('')
  const [ticker, setTicker] = useState('')
  const [description, setDescription] = useState('')
  const addAssetRequestMutation = useAddAssetRequest(name, ticker, description)
  const navigate = useNavigate()

  if (addAssetRequestMutation.isSuccess) {
    return (
      <MessageModal
        title="Successfully"
        status="success"
        onClick={onClose}
        message="Request has been sent"
        buttons={[
          (<Button onClick={onClose} wide>Continue</Button>),
          (
            <Button
              onClick={() => navigate('/feed')}
              secondary
              wide
            >
              Watch feed
            </Button>
          ),
        ]}
      />
    )
  }

  const handleChangeName = (e: React.FormEvent<HTMLInputElement>) => {
    setName((e.target as HTMLInputElement).value)
  }

  const handleChangeTicker = (e: React.FormEvent<HTMLInputElement>) => {
    setTicker((e.target as HTMLInputElement).value)
  }

  const handleChangeDescription = (e: React.FormEvent<HTMLInputElement>) => {
    setDescription((e.target as HTMLInputElement).value)
  }

  return (
    <Modal
      onClose={onClose}
      isOpen
      className={styles.container}
      onClick={(e: any) => e.stopPropagation()}
    >
      <div className={styles.title}>Request asset</div>

      <Input
        className={styles.input}
        value={name}
        onChange={handleChangeName}
        placeholder="Asset name"
        wide
      />
      <Input
        className={styles.input}
        value={ticker}
        onChange={handleChangeTicker}
        placeholder="Asset Ticker"
        wide
      />
      <Input
        className={styles.input}
        value={description}
        onChange={handleChangeDescription}
        placeholder="Description"
        wide
      />

      <Button
        className={styles.btn}
        onClick={() => addAssetRequestMutation.mutate()}
        wide
      >
        Send Request
      </Button>
    </Modal>
  )
}

export default AssetRequestModal
